import { createAction } from 'redux-actions'

const prefix = 'ALERTS/'

export const fetchAlertsStart = createAction(`${prefix}FETCH_ALERTS_START`)
export const fetchAlertsSuccess = createAction(`${prefix}FETCH_ALERTS_SUCCESS`)
export const fetchAlertsError = createAction(`${prefix}FETCH_ALERTS_ERROR`)

export const fetchAlertHistoryStart = createAction(`${prefix}FETCH_ALERT_HISTORY_START`)
export const fetchAlertHistorySuccess = createAction(`${prefix}FETCH_ALERT_HISTORY_SUCCESS`)
export const fetchAlertHistoryError = createAction(`${prefix}FETCH_ALERT_HISTORY_ERROR`)

export const updateSelectedAlert = createAction(`${prefix}UPDATE_SELECTED_ALERT`)

export const saveAlertStart = createAction(`${prefix}SAVE_ALERT_START`)
export const saveAlertSuccess = createAction(`${prefix}SAVE_ALERT_SUCCESS`)
export const saveAlertError = createAction(`${prefix}SAVE_ALERT_ERROR`)

export const updateAlertsStatusStart = createAction(`${prefix}UPDATE_ALERTS_STATUS_START`)
export const updateAlertsStatusSuccess = createAction(`${prefix}UPDATE_ALERTS_STATUS_SUCCESS`)
export const updateAlertsStatusError = createAction(`${prefix}UPDATE_ALERTS_STATUS_ERROR`)

export const deleteAlertStart = createAction(`${prefix}DELETE_ALERT_START`)
export const deleteAlertSuccess = createAction(`${prefix}DELETE_ALERT_SUCCESS`)
export const deleteAlertError = createAction(`${prefix}DELETE_ALERT_ERROR`)

export const deleteAlertsStart = createAction(`${prefix}DELETE_ALERTS_START`)
export const deleteAlertsSuccess = createAction(`${prefix}DELETE_ALERTS_SUCCESS`)
export const deleteAlertsError = createAction(`${prefix}DELETE_ALERTS_ERROR`)

export const executeAlertSavedSearch = createAction(`${prefix}EXECUTE_ALERT_SAVED_SEARCH`)

export const previewAlertStart = createAction(`${prefix}PREVIEW_ALERT_START`)
export const previewAlertSuccess = createAction(`${prefix}PREVIEW_ALERT_SUCCESS`)
export const previewAlertError = createAction(`${prefix}PREVIEW_ALERT_ERROR`)
export const hideAlertPreviewDialog = createAction(`${prefix}HIDE_ALERT_PREVIEW_DIALOG`)

export const showAlertDialog = createAction(`${prefix}SHOW_ALERT_DIALOG`)
export const showCreateAlertDialog = createAction(`${prefix}SHOW_CREATE_ALERT_DIALOG`)
export const hideAlertDialog = createAction(`${prefix}HIDE_ALERT_DIALOG`)

export const showRemoveAlertDialog = createAction(`${prefix}SHOW_REMOVE_ALERT_DIALOG`)
export const hideRemoveAlertDialog = createAction(`${prefix}HIDE_REMOVE_ALERT_DIALOG`)
